module.exports = "/packs/as_img02-20b853515cf664679ecfa0dfaa83caf9.png";